import { useAtomValue, useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { unwrappedMarkersDescriptionsAtom } from '@/atoms/eventMarkers';
import { eventLinkAtom } from '@/atoms/navigation';
import { unwrappedUserVideoAccessStatusAtom } from '@/atoms/user';
import { currentUnwrappedPitchEventsAtom } from '@/atoms/vis/currentPitchEvents';
import { selectVisEventsAtom } from '@/atoms/vis/selection';
import useGetLinkPath from '@/hooks/useGetLinkPath';
import { usePlayButtonFeedback } from '@/hooks/usePlayButtonFeedback';
import { useResetSelectionLayer } from '@/hooks/useResetSelectionLayer';

const ENABLED_VIDEO_STATUS = 'enabled';

export const usePlayAllEvents = () => {
  const { markerEvents, arrowEvents } = useAtomValue(currentUnwrappedPitchEventsAtom);
  const videoAccessStatus = useAtomValue(unwrappedUserVideoAccessStatusAtom);
  const eventDescriptions = useAtomValue(unwrappedMarkersDescriptionsAtom);
  const selectVisEvents = useSetAtom(selectVisEventsAtom);
  const resetSelectionLayer = useResetSelectionLayer();
  const { to, relative } = useGetLinkPath(eventLinkAtom);
  const navigate = useNavigate();

  const allEvents = [...markerEvents, ...arrowEvents];
  const hasDisplayedEvents = allEvents.length > 0;

  const disabled = videoAccessStatus !== ENABLED_VIDEO_STATUS || !hasDisplayedEvents;
  const disabledReason = usePlayButtonFeedback(videoAccessStatus);

  const playAllEvents = () => {
    resetSelectionLayer();
    selectVisEvents(allEvents, eventDescriptions);
    navigate(to, { relative });
  };

  return { playAllEvents, disabled, disabledReason };
};
